<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      prop="prescriptionId"
      label="处方编号"
      placeholder="请输入"
      width="330px"
      v-model="prescriptionId"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    ></label-input>
    <label-input
      prop="drugName"
      label="药品通用名"
      placeholder="请输入"
      width="330px"
      v-model="drugName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    ></label-input>
    <label-input
      prop="platformName"
      label="处方平台"
      placeholder="请输入"
      width="330px"
      v-model="platformName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    ></label-input>
    <label-input
      prop="hospitalName"
      label="医疗机构"
      placeholder="请输入"
      width="330px"
      v-model="hospitalName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    ></label-input>
    <label-input class="control" label="风险处方药品" prop="riskType" v-if="prescriptionDrugRisk == 1">
      <el-select v-model="riskType" placeholder="请选择">
        <el-option
          v-for="item in riskTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input class="control" label="开方时间" prop="registrationTime">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        align="right"
      ></el-date-picker>
    </label-input>
  </search-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import searchWrapper from '@/components/global/form/searchWrapper';
import labelInput from '@/components/global/form/labelInputForSupervision';

export default {
  name: 'searchBar',
  props: {
    searchParams: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    searchWrapper,
    labelInput
  },
  computed: {
    ...mapState('permission', ['supervisionConfig']),
    prescriptionDrugRisk() {
      return this.supervisionConfig?.prescriptionConfig?.prescriptionDrugRisk;
    },
    prescriptionId: {
      get() {
        return this.searchParams.prescriptionId;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'prescriptionId',
          value: val
        });
      }
    },
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    hospitalName: {
      get() {
        return this.searchParams.hospitalName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'hospitalName',
          value: val
        });
      }
    },
    platformName: {
      get() {
        return this.searchParams.platformName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'platformName',
          value: val
        });
      }
    },
    riskType: {
      get() {
        return this.searchParams.riskType;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'riskType',
          value: val
        });
      }
    },
    dateRange: {
      get() {
        return this.searchParams.registrationTime;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'registrationTime',
          value: val
        });
      }
    }, // patchedStatus
    patchedStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '补传', value: '1' },
        { label: '当日上传', value: '0' }
      ];
    },
    riskTypeOptions() {
      return [
        { label: '全部', value: null },
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ];
    },
    registrationStatusOptions() {
      return [
        { label: '全部', value: '' },
        { label: '待登记', value: '0' },
        { label: '已登记', value: '1' },
        { label: '未登记', value: '9' }
      ];
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const yesterday = dayjs().subtract(1, 'days');
              picker.$emit('pick', [
                yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }
        ]
      };
    }
  },
  methods: {
    search() {
      this.$emit('search');
    }
  }
};
</script>

<style lang="scss" scoped></style>
